import CardBankTypeEdit from './CardBankTypeEdit';
import CardBankTypesList from './CardBankTypesList';

const resource = {
  list: CardBankTypesList,
  edit: CardBankTypeEdit,
};

export default resource;
